import { hasAsset } from '@websrc/App/Helpers/hasAsset'
import React from 'react'

import { SpotCampaignAsset } from './SpotCampaignAsset'
import { SpotCampaignContent, SpotCampaignContentProps } from './SpotCampaignContent'
import * as SC from './SpotCampaignDesktop.style'

export const SpotCampaignDesktop: React.FC<SpotCampaignContentProps> = (props) => {
  const { bgColor, hasBackgroundImage, hasVideo, isReverse, spot } = props
  const { asset, is_background_image } = spot

  const hasTextContent = Boolean(spot.description || spot.headline)

  const thumbnailUrl = asset?.thumbnail?.url

  return (
    <SC.Wrapper>
      <SC.Background
        backgroundColor={bgColor}
        data-testid={`spot-campaign-bg-${bgColor}`}
        hasBackgroundImage={hasBackgroundImage}
        hasRegularImage={Boolean(asset?.thumbnail?.url && !is_background_image)}
        hasTextContent={hasTextContent}
        hasVideo={hasVideo}
        url={thumbnailUrl}
      >
        {hasTextContent && (
          <SC.ContentWrapper hasBackgroundImage={hasBackgroundImage} isReverse={isReverse}>
            <SpotCampaignContent {...props} />
          </SC.ContentWrapper>
        )}
        {hasAsset(asset) && !is_background_image && (
          <SC.AssetCol>
            <SpotCampaignAsset {...props} />
          </SC.AssetCol>
        )}
        {is_background_image && hasVideo && <SpotCampaignAsset {...props} />}
      </SC.Background>
    </SC.Wrapper>
  )
}
